/** @jsx jsx */
import PropTypes from "prop-types"
import { jsx } from "theme-ui"
import { LocalizedLink } from "gatsby-theme-i18n"
import { useLocalization } from "gatsby-theme-i18n"

const LocalizedButton = ({
  variant,
  to,
  language,
  children,
  sx,
  className,
}) => {
  const { locale } = useLocalization()
  return (
    <LocalizedLink
      to={to}
      language={language || locale}
      className={className}
      sx={{
        appearance: "none",
        display: "inline-block",
        textAlign: "center",
        lineHeight: "inherit",
        textDecoration: "none",
        m: 0,
        px: 3,
        py: 2,
        ...sx,
        // pass variant prop to sx
        variant: `buttons.${variant}`,
      }}
    >
      {children}
    </LocalizedLink>
  )
}

LocalizedButton.defaultProps = {
  variant: "primary",
}

LocalizedButton.propTypes = {
  variant: PropTypes.string,
  to: PropTypes.string,
  language: PropTypes.string,
  children: PropTypes.any,
  sx: PropTypes.object,
  className: PropTypes.string,
}

export default LocalizedButton
